import $cookies from 'vue-cookies'
import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '@/views/login/index'  //登录
import loginIndex from '@/views/login/loginIndex'  //登录2
import forgetPassword from '@/views/login/forgetPassword'  //忘记密码
import registeredIndex from '@/views/login/registeredIndex'  //免费注册
import main from '@/views/index'
import homePage from '@/views/home/homePage'  //首页
// 交易
import printOrderList from '@/views/transaction/orderManagement/printOrderList'   //打印订单
import printOrderDetails from '@/views/transaction/orderManagement/printOrderDetails'   //打印订单详情
import mallOrderList from '@/views/transaction/orderManagement/mallOrderList'   //商城订单
import designOrderList from '@/views/transaction/orderManagement/designOrderList'   //设计订单
import modelOrderList from '@/views/transaction/orderManagement/modelOrderList'   //模型订单
import severOrderList from '@/views/transaction/orderManagement/severOrderList'   //服务订单
import serverOrderDetails from '@/views/transaction/orderManagement/serverOrderDetails'   //服务订单详情
import softwareOrderList from '@/views/transaction/orderManagement/softwareOrderList'   //软件订单
import integralOrderList from '@/views/transaction/orderManagement/integralOrderList'   //积分订单
// import collectOrderList from '@/views/transaction/orderManagement/collectOrderList'   //集采订单


import tradShippAddress from '@/views/transaction/tradShippAddress'   //收货地址
import evaluationManagement from '@/views/transaction/evaluationManagement'   //评价管理
// 交易订单详情页
import mallOrderDetails from '@/views/transaction/orderManagement/mallOrderDetails'   //商城订单详情
import designOrderDetail from '@/views/transaction/orderManagement/designOrderDetail'   //设计订单详情页
import modelOrderDetail from '@/views/transaction/orderManagement/modelOrderDetail'   //模型订单详情页
import softwareOrderDetails from '@/views/transaction/orderManagement/softwareOrderDetails'   //软件订单详情
import integralOrderDetails from '@/views/transaction/orderManagement/integralOrderDetails'   //积分订单详情
// import collectOrderDetails from '@/views/transaction/orderManagement/collectOrderDetails'   //集采订单详情



// 模型
import modelUpload from '@/views/model/modelUpload'   //我上传的
import modelDownload from '@/views/model/modelDownload'   //我下载的

// 服务
import myInvoice from '@/views/service/myInvoice'   //我的发票
import invoiceManagement from '@/views/service/invoiceManagement'   //抬头管理
import addressManagement from '@/views/service/addressManagement'   //收票地址
import myComplaint from '@/views/service/myComplaint'   //我的投诉
import afterSalesService from '@/views/service/afterSalesService'   //售后服务


// 需求
import demandManagement from '@/views/management/demandManagement'   //需求管理
import modelManagement from '@/views/management/modelManagement'   //模型管理
import serveManagement from '@/views/management/serveManagement'   //服务管理
import newsManagement from '@/views/management/newsManagement'   //资讯收藏
import softwareManagement from '@/views/management/softwareManagement'   //软件收藏
import goodsManagement from '@/views/management/goodsManagement'   //商品收藏

// 活动
import activeJoin from '@/views/active/activeJoin'   //我参加的活动

// 关注
import serviceProviders from '@/views/focusOn/serviceProviders'   //服务商关注
import designerFocus from '@/views/focusOn/designerFocus'   //设计师关注

// 收藏
import demand from '@/views/demand/demand'   //需求收藏

// 商品
// 打印管理
import materialManagement from  '@/views/commodity/printManagement/materialManagement'  //材料管理
import serviceCapability from  '@/views/commodity/printManagement/serviceCapability'  //服务能力
import productDisplay from  '@/views/commodity/printManagement/productDisplay'  //成品展示
//消息
import stationMessageLog from '@/views/transaction/stationMessageLog/stationMessageLog'

// 足迹
import browsingHistory from '@/views/browsingHistory/browsingHistory'
//咨询
import consultInfo from '@/views/consultInfo/consultInfo'
//解决方案咨询
import solutionConsult from '@/views/solutionConsult/solutionConsult'
// 合同管理菜单
import contractManage from '@/views/contract/contractManage'   //合同预警
import moduleManage from '@/views/contract/moduleManage'   //模板管理
import signatureManage from '@/views/contract/signatureManage'   //签章管理


Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'login',
        //     redirect: '/login',
        //     component: loginPage,
        // },
        {
            path: '/',
            name: 'loginIndex',
            redirect: '/loginIndex',
            component: loginIndex,
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: loginPage,
        // },
        {
            path: '/loginIndex',
            name: 'loginIndex',
            component: loginIndex,
        },
        {
            path: '/forgetPassword',
            name: 'forgetPassword',
            component: forgetPassword,
        },
        {
            path: '/registeredIndex',
            name: 'registeredIndex',
            component: registeredIndex,
        },
        {
            path: '/home',
            name: 'home',
            redirect: '/home',
            component: main,
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: homePage,
                    meta: {title: '首页'}
                },
                {
                    path: '/printOrderList',
                    name: 'printOrderList',
                    component: printOrderList,
                    meta: {title: '打印订单'}
                },
                {
                    path: '/printOrderDetails/:uuid',
                    name: 'printOrderDetails',
                    component: printOrderDetails,
                    meta: { title: '打印订单详情' }
                },
                {
                    path: '/mallOrderList',
                    name: 'mallOrderList',
                    component: mallOrderList,
                    meta: {title: '商城订单'}
                },
                {
                  path: '/mallOrderDetails/:orderBaseUuid',
                  name: 'mallOrderDetails',
                  component: mallOrderDetails,
                  meta: {title: '商城订单'}
                },
                {
                    path: '/integralOrderDetails/:orderBaseUuid',
                    name: 'integralOrderDetails',
                    component: integralOrderDetails,
                    meta: {title: '积分订单'}
                },
                // {
                //     path: '/collectOrderDetails/:orderBaseUuid',
                //     name: 'collectOrderDetails',
                //     component: collectOrderDetails,
                //     meta: {title: '集采订单'}
                // },
                {
                    path: '/designOrderList',
                    name: 'designOrderList',
                    component: designOrderList,
                    meta: {title: '设计订单'}
                },
                {
                    path: '/designOrderDetail/:uuid/:type?',
                    name: 'designOrderDetail',
                    component: designOrderDetail,
                    meta: {title: '设计订单详情'}
                },
                {
                    path: '/modelOrderDetail',
                    name: 'modelOrderDetail',
                    component: modelOrderDetail,
                    meta: {title: '模型订单详情'}
                },

                {
                    path: '/modelOrderList',
                    name: 'modelOrderList',
                    component: modelOrderList,
                    meta: {title: '模型订单'}
                },
                {
                    path: '/severOrderList',
                    name: 'severOrderList',
                    component: severOrderList,
                    meta: {title: '服务订单'}
                },
                {
                    path: '/serverOrderDetails/:uuid',
                    name: 'serverOrderDetails',
                    component: serverOrderDetails,
                    meta: {title: '服务订单详情'}
                },
                {
                    path: '/softwareOrderList',
                    name: 'softwareOrderList',
                    component: softwareOrderList,
                    meta: {title: '软件订单'}
                },
                {
                    path: '/integralOrderList',
                    name: 'integralOrderList',
                    component: integralOrderList,
                    meta: {title: '积分订单'}
                },
                // {
                //     path: '/collectOrderList',
                //     name: 'collectOrderList',
                //     component: collectOrderList,
                //     meta: {title: '集采订单'}
                // },
                {
                  path: '/softwareOrderDetails',
                  name: 'softwareOrderDetails',
                  component: softwareOrderDetails,
                  meta: {title: '软件订单详情页'}
                },
                {
                    path: '/tradShippAddress',
                    name: 'tradShippAddress',
                    component: tradShippAddress,
                    meta: {title: '收货地址'}
                },
                {
                    path: '/evaluationManagement',
                    name: 'evaluationManagement',
                    component: evaluationManagement,
                    meta: {title: '评价管理'}
                },
                // 模型
                {
                    path: '/modelUpload',
                    name: 'modelUpload',
                    component: modelUpload,
                    meta: {title: '我上传的'}
                },
                {
                    path: '/modelDownload',
                    name: 'modelDownload',
                    component: modelDownload,
                    meta: {title: '我下载的'}
                },
                {
                    path: '/myInvoice',
                    name: 'myInvoice',
                    component: myInvoice,
                    meta: {title: '我的发票'}
                },
                {
                    path: '/invoiceManagement',
                    name: 'invoiceManagement',
                    component: invoiceManagement,
                    meta: {title: '抬头管理'}
                },
                {
                    path: '/addressManagement',
                    name: 'addressManagement',
                    component: addressManagement,
                    meta: {title: '收票地址'}
                },
                {
                    path: '/myComplaint',
                    name: 'myComplaint',
                    component: myComplaint,
                    meta: {title: '我的投诉'}
                },
                {
                    path: '/afterSalesService',
                    name: 'afterSalesService',
                    component: afterSalesService,
                    meta: {title: '售后服务'}
                },
                {
                    path: '/demandManagement',
                    name: 'demandManagement',
                    component: demandManagement,
                    meta: {title: '需求管理'}
                },
                {
                    path: '/newsManagement',
                    name: 'newsManagement',
                    component: newsManagement,
                    meta: {title: '资讯收藏'}
                },
                {
                    path: '/softwareManagement',
                    name: 'softwareManagement',
                    component: softwareManagement,
                    meta: {title: '软件收藏'}
                },
                {
                    path: '/goodsManagement',
                    name: 'goodsManagement',
                    component: goodsManagement,
                    meta: {title: '商品收藏'}
                },
                {
                    path: '/activeJoin',
                    name: 'activeJoin',
                    component: activeJoin,
                    meta: {title: '活动'}
                },
                {
                    path: '/modelManagement',
                    name: 'modelManagement',
                    component: modelManagement,
                    meta: {title: '模型管理'}
                },
                {
                    path: '/serveManagement',
                    name: 'serveManagement',
                    component: serveManagement,
                    meta: {title: '服务管理'}
                },
                {
                    path: '/serviceProviders',
                    name: 'serviceProviders',
                    component: serviceProviders,
                    meta: {title: '服务商关注'}
                },
                {
                    path: '/designerFocus',
                    name: 'designerFocus',
                    component: designerFocus,
                    meta: {title: '设计师关注'}
                },
                {
                    path: '/materialManagement',
                    name: 'materialManagement',
                    component: materialManagement,
                    meta: {title: '材料管理'}
                },
                {
                    path: '/serviceCapability',
                    name: 'serviceCapability',
                    component: serviceCapability,
                    meta: {title: '服务能力'}
                },
                {
                    path: '/productDisplay',
                    name: 'productDisplay',
                    component: productDisplay,
                    meta: {title: '成品展示'}
                },
                {
                    path: '/demand',
                    name: 'demand',
                    component: demand,
                    meta: {title: '需求管理'}
                },
                {
                    path: '/stationMessageLog',
                    name: 'stationMessageLog',
                    component: stationMessageLog,
                    meta: {title: '消息'}
                },
                {
                    path: '/browsingHistory',
                    name: 'browsingHistory',
                    component: browsingHistory,
                    meta: {title: '足迹'}
                },
                {
                    path: '/consultInfo',
                    name: 'consultInfo',
                    component: consultInfo,
                    meta: {title: '我的咨询'}
                },
                {
                    path: '/solutionConsult',
                    name: 'solutionConsult',
                    component: solutionConsult,
                    meta: {title: '解决方案咨询'}
                },
                {
                    path: '/contractManage',
                    name: 'contractManage',
                    component: contractManage,
                    meta: {title: '合同管理'}
                },
                {
                    path: '/moduleManage',
                    name: 'moduleManage',
                    component: moduleManage,
                    meta: {title: '模板管理'}
                },
                {
                    path: '/signatureManage',
                    name: 'signatureManage',
                    component: signatureManage,
                    meta: {title: '签章管理'}
                },
            ]
        },
    ]
})
router.beforeEach((to, from, next) => {
    let token = $cookies.get("api_token_new");
    if (to.name !== 'loginIndex' && !token) {
        next({ name: 'loginIndex' })
    } else if(to.name == 'loginIndex' && token){
        next({ name: 'home' })
    }

    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js